import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './NavLink.module.scss';
import UserIcon from '../../../assets/Imagess/userIcon.svg';
import chevronDown from '../../../assets/Imagess/chevron-down.svg';

import { isEmpty, set } from 'lodash';
import { DetailsContext } from '../../HOC/GeneralBody/GeneralBody';

const NavLink = ({ navPageLinks }) => {
  const [activeLink, setActiveLink] = useState('Dashboard');
  const [expandedSection, setExpandedSection] = useState(null);
  const location = useLocation();
  const Details = useContext(DetailsContext);

  /**
   * Does `path` own the current location — exactly, or as a section prefix?
   * The prefix form keeps a detail route (`/home/news/edit/5`) attached to its
   * list link (`/home/news`); the trailing `/` guard stops `/home/news` from
   * also claiming `/home/news-letter`.
   */
  const ownsCurrentPath = (path, currentPath) =>
    Boolean(path) &&
    (currentPath === path || currentPath.startsWith(`${path}/`));

  useEffect(() => {
    const currentPath = location.pathname;
    setActiveLink(currentPath);

    // AUTO-EXPAND the group that owns the current route. Without this, opening
    // a nested screen directly (a bookmark, a refresh, a link) left its parent
    // collapsed - the link to the page the operator was ON was not even
    // visible, and its sibling screens were unreachable until they guessed
    // which group to open. Navigation only ever OPENS the owning group; it
    // never closes one the operator opened by hand.
    const owner = (navPageLinks ?? []).find((link) =>
      (link?.nested ?? []).some((nested) =>
        ownsCurrentPath(nested?.path, currentPath)
      )
    );
    if (owner) setExpandedSection(owner.name);
  }, [location.pathname, navPageLinks]);

  const toggleExpandedSection = (sectionName) => {
    setExpandedSection(expandedSection === sectionName ? null : sectionName);
  };

  const handleDetails = () => {
    Details.setDetails(null);
  };

  return (
    <nav>
      {navPageLinks?.map((link) => {
        return !isEmpty(link.nested) ? (
          <React.Fragment key={link.name}>
            <div
              onClick={() => toggleExpandedSection(link.name)}
              className={`${styles.link} ${
                activeLink === link.path ? styles.active : ''
              }`}
            >
              <div className={styles['img-cont']}>
                <img src={link.icon} alt={link.name?.toLowerCase()} />
                <p>{link.name}</p>
              </div>
              <img
                src={chevronDown}
                className={`${styles['chevron-up']} ${
                  expandedSection === link.name ? styles.open : ''
                }`}
              />
            </div>
            {expandedSection === link.name &&
              link.nested.map((nestedLink) => (
                <Link
                  key={nestedLink.name}
                  to={nestedLink.path}
                  className={`${styles.nested} ${
                    ownsCurrentPath(nestedLink.path, activeLink)
                      ? styles.active
                      : ''
                  }`}
                >
                  <div onClick={handleDetails}>
                    <div className={styles['img-cont']}>
                      {' '}
                      <img
                        src={nestedLink.icon}
                        alt={nestedLink.name?.toLowerCase()}
                      />
                      <p>{nestedLink.name}</p>
                    </div>
                  </div>
                </Link>
              ))}
          </React.Fragment>
        ) : (
          <Link
            key={link.name}
            to={link.path}
            className={`${styles.link} ${
              activeLink === link.path ? styles.active : ''
            }`}
          >
            <div onClick={handleDetails} className={styles['navlink']}>
              <div className={styles['img-cont']}>
                <img src={link.icon} alt={link.name?.toLowerCase()} />
                <p>{!isEmpty(link.title) ? link.title : link.name}</p>
              </div>
            </div>
          </Link>
        );
      })}
    </nav>
  );
};

export default NavLink;
